import { useEffect, useState } from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Layout from '../Layout.jsx'
import { ToastProvider } from './components/ui/toast.jsx'
import Landing from '../Pages/Landing.jsx'
import CreateTest from '../Pages/CreateTest.jsx'
import TestCases from '../Pages/TestCases.jsx'
import EvaluationRuns from '../Pages/EvaluationRuns.jsx'
import EvaluationResults from '../Pages/EvaluationResults.jsx'
import Tutorial from './components/Tutorial.jsx'
import AuthWrapper from '../auth/AuthWrapper'
import { useIsAuthenticated } from '@azure/msal-react'

function App() {
  const [runTutorial, setRunTutorial] = useState(false)
  const isAuthenticated = useIsAuthenticated()
  
  // eslint-disable-next-line no-unused-expressions
  Router && Routes && Route && Layout && ToastProvider && Landing && CreateTest && TestCases && EvaluationRuns && EvaluationResults && Tutorial && AuthWrapper;

  useEffect(() => {
    // Tutorial never auto-starts - only triggered by user action
    setRunTutorial(false)
  }, [isAuthenticated])

  const finishTutorial = () => {
    setRunTutorial(false)
  }

  const startTutorial = () => {
    if (!isAuthenticated) {
      alert('You must log in or create an account before starting a tutorial.')
      return
    }
    setRunTutorial(true)
  }

  return (
    <Router>
      <ToastProvider>
      {/* Only show tutorial for authenticated users */}
      {isAuthenticated && <Tutorial run={runTutorial} onFinish={finishTutorial} />}
      <Routes>
        {/* Public route - Landing page accessible to everyone */}
        <Route 
          path="/" 
          element={<Landing onStartTutorial={startTutorial} />} 
        />
        
        {/* Protected routes - require authentication */}
        <Route
          path="/CreateTest"
          element={
            <AuthWrapper>
              <Layout currentPageName="CreateTest" onStartTutorial={startTutorial}>
                <CreateTest />
              </Layout>
            </AuthWrapper>
          }
        />
        <Route
          path="/TestCases"
          element={
            <AuthWrapper>
              <Layout currentPageName="TestCases" onStartTutorial={startTutorial}>
                <TestCases />
              </Layout>
            </AuthWrapper>
          }
        />
        <Route
          path="/EvaluationRuns"
          element={
            <AuthWrapper>
              <Layout currentPageName="EvaluationRuns" onStartTutorial={startTutorial}>
                <EvaluationRuns />
              </Layout>
            </AuthWrapper>
          }
        />
        <Route
          path="/EvaluationResults"
          element={
            <AuthWrapper>
              <Layout currentPageName="EvaluationResults" onStartTutorial={startTutorial}>
                <EvaluationResults />
              </Layout>
            </AuthWrapper>
          }
        />
      </Routes>
      </ToastProvider>
    </Router>
  )
}

export default App
